/**
 * 系统指令的存放目录
 */

import * as directive from './directive';

export default {
  ...directive,
};
